import { Pipe, PipeTransform } from '@angular/core';

import { format } from 'date-fns';

@Pipe({name: 'momentFormatTime'})
export class DateFnsFormatTimePipe implements PipeTransform {
    transform(time: any, formatTo: string): any {
        return format(new Date(time), formatTo);
    }
}
